import About from "./About";
import Projects from "./Projects";
import Skills from "./Skills";

export default function Home() {

    return (
      <>
          <About />
          <Projects />
          <Skills />
      </>
    );
}